module.exports = __webpack_public_path__ + "img/popup.fc89825e.jpg";